export const createAccount = `
    mutation CreateAccount($input: CreateAccountInput!) {
        createAccount(input: $input) {
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            created
            updated
        }
    }
`;

export const updateAccount = `
    mutation UpdateAccount($input: UpdateAccountInput!) {
        updateAccount(input: $input) {
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            created
            updated
        }
    }
`;

export const deleteAccount = `
    mutation DeleteAccount($input: DeleteAccountInput!) {
        deleteAccount(input: $input)
    }
`;

// FNP-383: restoreAccount flips a PENDING_DELETION account back to ACTIVE
// within the 30-day retention window. Admin-only on the backend (FNP-382
// directive). The mutation returns the restored Account so the UI can
// reflect the new accountStatus + cleared retention fields immediately.
export const restoreAccount = `
    mutation RestoreAccount($input: RestoreAccountInput!) {
        restoreAccount(input: $input) {
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            created
            updated
        }
    }
`;
